<a mat-list-item class="menu-list-item">
  <div class="container" fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex="15" fxLayoutAlign="start center">
      <mat-icon>power_settings_new</mat-icon>
    </div>
    <div fxFlex="75%" (click)="logout()">Abmelden</div>
    <div fxFlex="10%"></div>
  </div>
</a>
